<form [formGroup]="damageReportTabForm" *ngIf="municipalityConfig$ | async as municipalityConfig">
  <mat-card>
    <mat-card-content class="full-width">
      <label class="label">{{ 'module.userProfile.generalConfiguration.damageReportLabel' | translate }}</label>
      <div class="form-group-top" *ngIf="isBAGCompany">
        <label class="label">{{ 'module.userProfile.generalInformation.customerCenterLabelText' | translate }}</label>
        <app-dropdown class="app-dropdown" [value]="selectedCustomerCenter" [disabled]="isDisabled">
          <app-dropdown-option
            class="dropdown-option"
            *ngFor="let customerCenter of municipalityConfig.customerCenter.data"
            [value]="customerCenter"
            (optionSelect)="selectCustomerCenter(customerCenter)"
          >
            {{ customerCenter.name }}
          </app-dropdown-option>
        </app-dropdown>
      </div>

      <div class="form-group-top">
        <label class="label">{{ 'module.userProfile.generalInformation.recipientLabelText' | translate }}</label>
        <mat-form-field class="form-field">
          <input title="recipient" class="input" [value]="damageReportEmailAddress" disabled matInput autocomplete="off" />
        </mat-form-field>
      </div>

      <div class="bottom-container">
        <div class="bottom-inside-container-left">
          <div class="form-group-top">
            <div class="toggle-inside-container-top">
              <mat-slide-toggle [disabled]="isDisabled" labelPosition="before" formControlName="dmgRepPwaactive" (change)="changeEventHandler()">
              </mat-slide-toggle>
              <label class="label">{{ 'module.userProfile.generalConfiguration.webAppLabel' | translate }}</label>
            </div>
            <div class="toggle-inside-container-top">
              <mat-slide-toggle
                [disabled]="isDisabled"
                labelPosition="before"
                formControlName="isGeneralReportingDamageEnabled"
                (change)="changeEventHandler()"
              >
              </mat-slide-toggle>
              <label class="label">{{ 'module.userProfile.generalConfiguration.damagePictureText' | translate }}</label>
            </div>
            <div class="toggle-inside-container">
              <mat-slide-toggle
                [disabled]="isDisabled"
                class="isActiveToggle"
                formControlName="isInTestMode"
                labelPosition="before"
                (change)="changeEventHandler()"
              >
              </mat-slide-toggle>
              <label class="label">{{ 'module.userProfile.generalConfiguration.testModusText' | translate }}</label>
            </div>
          </div>
        </div>
        <div class="delete-data-container">
          <div class="label-gray">
            {{ 'module.userProfile.deleteTestData.instructionText' | translate }}
          </div>
          <button type="button" class="btn btn-outline-danger" (click)="deleteTestData()">
            {{ 'module.userProfile.deleteTestData.deleteTestDataButtonText' | translate }}
          </button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</form>
